import { render, staticRenderFns } from "./Page13.vue?vue&type=template&id=b49c561e&scoped=true&"
import script from "./Page13.vue?vue&type=script&lang=ts&"
export * from "./Page13.vue?vue&type=script&lang=ts&"
import style0 from "./Page13.vue?vue&type=style&index=0&id=b49c561e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49c561e",
  null
  
)

export default component.exports